<template>
  <div class="clients-actions">
    <div class="spacer" />
    <div class="search">
      <tol-type-ahead
        :search-params="{
          url: `/clients/${clientReference}`,
          searchKeys: ['searchParam'],
          urlParams: {
            sortBy: '',
            sortDirection: '',
            clientsFilterPreference: '',
            clientsTypeFilterPreference: '',
            contactsRecordsPerPage: getClientDetailsContactsRecordsPerpage,
            contactsRecordsOffset: getClientDetailsContactsRecordsOffset
          }
        }"
        :results-in-dropdown="false"
        @filtered="onFiltered($event)"
      >
      </tol-type-ahead>
    </div>
  </div>
</template>
<script>
import TolTypeAhead from '@/app/components/TolTypeAhead';
import { ClientDetailsGetters, ClientDetailsActions } from '../client-details.keys';
import vClickOutside from 'v-click-outside';
import { mapGetters } from 'vuex';
export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    TolTypeAhead
  },
  props: {
    titleAllOrFiltered: {
      type: String,
      default: 'clients.listing.all'
    },
    clientReference: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      ClientDetailsGetters.GetClientDetailsContactsRecordsPerPage,
      ClientDetailsGetters.GetClientDetailsContactsRecordsCount,
      ClientDetailsGetters.GetClientDetailsContactsRecordsOffset
    ])
  },

  methods: {
    onFiltered(results) {
      this.$store.dispatch(ClientDetailsActions.ClientDetailsContactsSearchUpdate, results);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.clients-actions {
  display: flex;
  background-color: $background-level-2;
  padding: 5px;

  .listing-title {
    color: $text-color-dark;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.24px;
    line-height: 28px;
  }
  .action-btns {
    display: flex;
    position: relative;
    margin-left: auto;

    justify-content: flex-end;
    flex-basis: 200px;
  }
  .dropdown-display {
    border-right: 1px solid $row-border;
    border-left: 1px solid $row-border;
    border-bottom: 1px solid $row-border;
    font-weight: bold;
  }

  .spacer {
    flex-grow: 1;
  }

  .search {
    margin-left: auto;
    display: block;
  }
}
</style>
